import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRefund = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#prefix__clip0_2_826)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "prefix__a",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M38 0H0v38h38V0z",
				fill: "#fff"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#prefix__a)",
			stroke: "#3C527D",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			children: [/* @__PURE__ */ _jsx("path", { d: "M2.98 12.673A17.23 17.23 0 111.782 19" }), /* @__PURE__ */ _jsx("path", {
				d: "M3.576 2.944l-.607 9.733 9.315-3.238M19 9.5v19M23.117 12.034A12.062 12.062 0 0019 11.4c-2.185 0-5.066.95-5.066 3.484 0 4.75 10.133 2.553 10.133 7.6 0 2.51-2.49 3.482-5.067 3.482a12.23 12.23 0 01-5.066-.95",
				strokeLinecap: "square"
			})]
		})]
	})
});
export default SvgRefund;
